import React from 'react';
import './blogitem.css';
import { Tooltip } from 'react-tooltip';

const BlogItem = ({ image, title, description, created, handleDelete, id }) => {
  // Format the date to exclude time
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  // Function to decode HTML entities
  const decodeHtmlEntities = (text) => {
    const parser = new DOMParser();
    const decodedString = parser.parseFromString(text, 'text/html').documentElement.textContent;
    return decodedString;
  };

  const tooltipId = `blogTitleTooltip-${id}`; // Generate unique Tooltip ID

  return (
    <div className="blog-item">
      <img src={image} alt={title} className="blog-image" />

      <div className="blog-content">
        <span className="blog-date">{formatDate(created)}</span>

        {/* Blog Title with Tooltip */}
        <h3
          className="grid-item-title"
          data-tooltip-id={tooltipId} // Unique Tooltip ID
          data-tooltip-content={title} // Tooltip content
        >
          {title}
        </h3>

        <Tooltip
          id={tooltipId} // Unique Tooltip ID
          place="top"
          style={{
            backgroundColor: '#333',
            color: '#fff',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            maxWidth: '300px',
            padding: '10px',
            zIndex: 9999,
          }}
        />

        <div className="blog-description">
          {decodeHtmlEntities(description.replace(/<\/?[^>]+(>|$)/g, '')).substring(0, 60)}
        </div>

        <div className="blog-actions">
          <center>
            <button className="blog-delete" onClick={() => handleDelete(id)}>
              Delete
            </button>
          </center>
        </div>
      </div>
    </div>
  );
};

export default BlogItem;
